import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../index'
import TagManager from 'react-gtm-module'

const { env } = window

const useUser = () => {
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()

  const getUser = async () => {
    const url = encodeURI(`${env.apiUrl}/userInfo`)
    const response = await securedFetch(url)
    await handleResponse(response)
    const data = await response.json()
    data.fullName = [data.firstName, data.lastName].filter(Boolean).join(' ')
    return data
  }

  const query = useQuery({
    queryKey: ['user'],
    queryFn: getUser,
    enabled: !!loggedIn
  })
  const user = loggedIn ? query.data : undefined

  TagManager.dataLayer({
    dataLayer: { user_id: user?.userId }
  })

  useEffect(() => {
    if (query.isError) {
      handleError(query.error, 'Error getting user')
    }
  }, [query.isError, query.error, handleError])

  return { user }
}

export { useUser }
